/**
 * Types for Insights embed PostMessage communication
 * Must match Insights' helpers/embedMessaging.ts constants
 */

// Message types - MUST match Insights' INSIGHTS_MESSAGES
export const INSIGHTS_MESSAGES = {
  // Incoming from Insights (Insights -> React)
  READY: "INSIGHTS_READY",
  ROUTE_CHANGE: "INSIGHTS_ROUTE_CHANGE",
  ERROR: "INSIGHTS_ERROR",
  NAVIGATE_PARENT: "INSIGHTS_NAVIGATE_PARENT",

  // Outgoing to Insights (React -> Insights)
  NAVIGATE: "INSIGHTS_NAVIGATE",
} as const;

export interface InsightsEmbedRef {
  /** Navigate to a path within Insights */
  navigate: (path: string) => void;
  /** Check if Insights is ready */
  readonly isReady: boolean;
}

export interface InsightsEmbedProps {
  /** Initial path within Insights (e.g., '/dashboards', '/workbook/test') */
  initialPath?: string;
  /** Additional className for container */
  className?: string;
  /** Called when Insights is ready */
  onReady?: () => void;
  /** Called when route changes within Insights */
  onRouteChange?: (path: string, title: string) => void;
  /** Called on error */
  onError?: (error: string) => void;
  /** Called when Insights requests parent navigation (e.g., back button) */
  onNavigateParent?: (action: string) => void;
}

export interface InsightsMessage {
  type: string;
  payload?: unknown;
  source?: string;
  timestamp?: number;
}

// Payload types
export interface InsightsReadyPayload {
  path: string;
  title?: string;
}

export interface InsightsRouteChangePayload {
  path: string;
  title?: string;
}

export interface InsightsErrorPayload {
  message: string;
  details?: string;
}

export interface InsightsNavigatePayload {
  path: string;
}

export interface InsightsNavigateParentPayload {
  action: "back" | "home" | string; // 'back', 'home', or a path
}
